import React from 'react';
import {isGbpMenuIcon, isQrMenuIcon} from './dashboardMenuUtils';

export default function DashboardMenuIcon({iconClass}) {
    if (isGbpMenuIcon(iconClass)) {
        return <span className="dashboard-menu-gbp">£</span>;
    }

    if (isQrMenuIcon(iconClass)) {
        return (
            <svg
                className="dashboard-menu-qr"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    fill="currentColor"
                    d="M3 3h7v7H3V3zm2 2v3h3V5H5zm9-2h7v7h-7V3zm2 2v3h3V5h-3zM3 14h7v7H3v-7zm2 2v3h3v-3H5zm11 1h2v2h-2v-2zm0 3h2v2h-2v-2zm3-3h2v2h-2v-2zm0 3h2v2h-2v-2zm-6 0h2v2h-2v-2zm3-3h2v2h-2v-2zm3 3h2v2h-2v-2z"
                />
            </svg>
        );
    }

    return <i className={iconClass}/>;
}
